// Per-route status-bar styling seam (MobileShell "per-route StatusBar style"). The native
// StatusBar plugin lives in the wrapper's SPM plugin set — accessed here via `registerPlugin` so
// @cntrl/native needs no extra npm dep (the typed @capacitor/status-bar package is itself only a thin
// `registerPlugin('StatusBar')` wrapper). No-op on web, mirroring token-provider/push/lifecycle glue.
import { Capacitor, registerPlugin } from "@capacitor/core";

interface StatusBarPlugin {
  setStyle(options: { style: "DARK" | "LIGHT" | "DEFAULT" }): Promise<void>;
}

const StatusBar = registerPlugin<StatusBarPlugin>("StatusBar");

/**
 * Set the status-bar CONTENT (text/icon) color for the current route. Expressed by intent
 * <c>"dark"</c> = dark content for the light CNTRL surfaces, <c>"light"</c> = light content for immersive dark
 * surfaces (Spotlight, DOS hero). NB the Capacitor <c>Style</c> enum is INVERTED (it names the background):
 * <c>Style.Light</c> renders dark content, <c>Style.Dark</c> renders light content — mapped below so callers
 * never have to remember it. No-op on web (there is no native status bar).
 */
export function setStatusBarStyle(content: "dark" | "light"): void {
  if (!Capacitor.isNativePlatform()) return;
  void StatusBar.setStyle({ style: content === "light" ? "DARK" : "LIGHT" });
}
